import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import ScoreCalculationConfiguration from "./routes/ScoreCalculationConfiguration";
import GradingMethodology from "./routes/GradingMethodology";
import CategorySetsConfiguration from "./routes/CategorySetsConfiguration";
import GradingCategoriesConfiguration from "./routes/GradingCategoriesConfiguration";
import GradeScales from "./routes/GradeScales";
import StandardCalculationConfiguration from "./routes/StandardCalculationConfiguration";
import GradeScalesAndDescriptors from "./routes/GradeScalesAndDescriptors";
import VisibilitySettings from "./routes/VisibilitySettings";
import MYPCriteriaBasedGrading from "./routes/MYPCriteriaBasedGrading";
import LearningGoalsGrading from "./routes/LearningGoalsGrading";
import ProjectProgressIndicators from "../ProjectProgressIndicators";
import AdminFinalGradeSetup from "./routes/AdminFinalGradeSetup";

export default store => ({
  path: "grading",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    ScoreCalculationConfiguration(store),
    GradingMethodology(store),
    GradingCategoriesConfiguration(store),
    CategorySetsConfiguration(store),
    GradeScales(store),
    StandardCalculationConfiguration(store),
    GradeScalesAndDescriptors(store),
    VisibilitySettings(store),
    MYPCriteriaBasedGrading(store),
    LearningGoalsGrading(store),
    ProjectProgressIndicators(store),
    AdminFinalGradeSetup(store),
  ],
});
